import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=fd454e24&"
import script from "./FileThumbnail.vue?vue&type=script&lang=js&"
export * from "./FileThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports